import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { identifiableName } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import ActionDialogForm from '@/components/dialogs/ActionDialogForm';
import ArchivalDialogConfirmation, { validateArchivalForm } from '@/components/dialogs/ArchivalDialogConfirmation';
import ActionDialogItems from '@/components/dialogs/ActionDialogItems';
import UserArchivalOptions from '../components/UserArchivalOptions';
import { hideArchiveUser, archiveUsers } from '../actions';
import UserArchivalTable from '../components/UserArchivalTable';

const UserArchivalDialog = ({
  archiveData,
  hide,
  results,
  theme,
}) => {
  const intl = useIntl();
  const [confirmation, setConfirmation] = React.useState('');
  const [reason, setReason] = React.useState('');
  const [disableTokens, setDisableTokens] = React.useState(true);
  const [archiveRequests, setArchiveRequests] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState([]);
  const name = identifiableName(results);

  const confirmed = () => ((results.length > 1)
    ? confirmation.toLowerCase() === intl.formatMessage({ id: 'actions.yes' }).toLowerCase()
    : confirmation === name);

  const saving = () => results.some((result) => result.destroyStatus === states.PENDING);

  const resetState = () => {
    setConfirmation('');
    setReason('');
    setDisableTokens(true);
    setArchiveRequests(false);
    setValidationErrors([]);
  };

  const handleClose = () => {
    resetState();
    hide();
  };

  const checkForErrors = () => {
    const errors = validateArchivalForm('user', reason, true);
    setValidationErrors(errors);

    return errors;
  };

  const submitForm = () => {
    const errors = checkForErrors();

    if (errors.length === 0) {
      archiveData(results, reason, disableTokens, archiveRequests);
      resetState();
    }
  };

  return (
    <ActionDialogForm
      action="archive"
      className="aridhia-user-archival-dialog"
      entity="user"
      entities="users"
      items={results}
      inProgress={saving()}
      minimumDataEntryMet={confirmed()}
      modalIcon="archive"
      onClick={submitForm}
      onClose={handleClose}
      theme={theme}
    >
      <ArchivalDialogConfirmation
        confirmText={confirmation}
        disabled={saving()}
        entities="users"
        entity="user"
        items={results}
        minimumDataEntryMet={confirmed}
        onChangeConfirmation={setConfirmation}
        onChangeReason={setReason}
        reason={reason}
        submitForm={submitForm}
        validationErrors={validationErrors}
      >
        <UserArchivalOptions
          archiveRequests={archiveRequests}
          disabled={saving()}
          disableTokens={disableTokens}
          toggleRequests={() => setArchiveRequests(!archiveRequests)}
          toggleTokens={() => setDisableTokens(!disableTokens)}
        />
      </ArchivalDialogConfirmation>
      {results.length > 1 && (
        <ActionDialogItems action="archive" icon="user" entities="users">
          <UserArchivalTable items={results} />
        </ActionDialogItems>
      )}
    </ActionDialogForm>
  );
};

const mapStateToProps = ({
  auth: { users: { archival: { results } } },
}) => ({
  results,
});

const mapDispatchToProps = {
  hide: hideArchiveUser,
  archiveData: archiveUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserArchivalDialog);
